import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faDownload, faFile, faUser } from '@fortawesome/free-solid-svg-icons';
import { IMAGE_FORMAT, Note } from '@univacity/shared/types';

@Component({
  selector: 'un-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoteComponent {
  @Input() note: Note;
  faFile = faFile;
  faUser = faUser;
  faDownload = faDownload;
  format = IMAGE_FORMAT.png;
  timeout = 21600;
  quality = 100;
}
